import {backendGetRequest} from '../../../common/utils/requests'

export const payoutCertificatePath = (withdrawalId: number | string) =>
  `/api/payout-certificates/${encodeURIComponent(String(withdrawalId))}/pdf`

export const canDownloadPayoutCertificate = (row: {payoutCertificateAvailable?: boolean | null} | null | undefined) =>
  Boolean(row && row.payoutCertificateAvailable === true)

/** Fetches the PDF with the session cookie and hands it to the browser as a file. Returns false on any failure. */
export const downloadPayoutCertificate = async (withdrawalId: number | string): Promise<boolean> => {
  try {
    const response = await backendGetRequest(payoutCertificatePath(withdrawalId), true)
    if (!response || !response.ok) return false
    const blob = await response.blob()
    const objectUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = objectUrl
    link.download = `payout-certificate-${withdrawalId}.pdf`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    // Safari starts the download after the click returns, so the URL must outlive the click.
    setTimeout(() => window.URL.revokeObjectURL(objectUrl), 60000)
    return true
  } catch (e) {
    return false
  }
}
